const AppConfig = {
  appName: 'Steyn City',
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/config/AppConfig.ts